module.exports = __webpack_public_path__ + "static/media/login_ilustration.4182bd6f.png";